import { apiClient } from './apiClient';
import { AuditLog } from '../types/auditLog';

type ListParams = {
  action?: string;
  user?: string;
  target_type?: string;
  target_id?: number;
  page?: number;
};

type PaginatedResponse<T> = {
  data: T[];
  meta: {
    current_page: number;
    last_page: number;
    total: number;
  };
};

export async function listAuditLogs(token: string, params: ListParams = {}) {
  const query = new URLSearchParams();

  if (params.action) query.set('action', params.action);
  if (params.user) query.set('user', params.user);
  if (params.target_type) query.set('target_type', params.target_type);
  if (params.target_id) query.set('target_id', String(params.target_id));
  if (params.page) query.set('page', String(params.page));

  const path = `/audit-logs${query.toString() ? `?${query.toString()}` : ''}`;

  return apiClient<PaginatedResponse<AuditLog>>(path, {
    method: 'GET',
    token,
  });
}

